
import helperMixin from '@/mixin/helper';
import ControllablePopover from '@com/components/preview-popover/controllable-popover.vue';
import horizontal from '@/assets/orientation/horizontal.png';
import vertical from '@/assets/orientation/vertical.png';
import AutoTips from '@/components/AutoTips';

export default {
  name: 'OrientationItem',
  mixins: [helperMixin],
  components: { ControllablePopover: ControllablePopover, AutoTips: AutoTips },
  props: {
    value: {
      type: [Number, String]
    },
    prop: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var h = this.$createElement;

    return {
      rules: [{
        required: true,
        trigger: 'change',
        message: this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.placeholder')
      }],
      options: [{
        value: 3,
        label: this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.adaptive.label'),
        desc: this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.adaptive.desc'),
        tips: this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.adaptive.tips')
      }, {
        value: 1,
        label: this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.landscape.label'),
        desc: h(
          'div',
          null,
          [h(
            'span',
            null,
            [this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.landscape.desc'), '\xA0', h(
              'controllable-popover',
              {
                attrs: {
                  'popover-props': {
                    placement: 'top-start'
                  }
                },
                scopedSlots: {
                  default: function _default() {
                    return h(
                      'el-image',
                      {
                        attrs: { src: horizontal }
                      },
                      []
                    );
                  },
                  reference: function reference(_ref) {
                    var show = _ref.show,
                        hide = _ref.hide;

                    return h(
                      'svg-icon',
                      {
                        nativeOn: {
                          'mouseenter': show,
                          'mouseleave': hide
                        },

                        'class': 'svg-common like-link',
                        attrs: { 'icon-class': 'question'
                        }
                      },
                      []
                    );
                  }
                }
              },
              []
            ), this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.see')]
          ), h(
            'a',
            {
              attrs: {
                href: 'javascript:void'
              },
              'class': 'like-link',
              on: {
                'click': this.openHelper,
                'mouseOver': this.openHelper
              }
            },
            [this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.help')]
          )]
        )
      }, {
        value: 2,
        label: this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.portrait.label'),
        desc: h(
          'div',
          null,
          [h(
            'span',
            null,
            [this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.portrait.desc'), '\xA0', h(
              'controllable-popover',
              {
                attrs: {
                  'popover-props': {
                    placement: 'top-start'
                  }
                },
                scopedSlots: {
                  default: function _default() {
                    return h(
                      'el-image',
                      {
                        attrs: { src: vertical }
                      },
                      []
                    );
                  },
                  reference: function reference(_ref2) {
                    var show = _ref2.show,
                        hide = _ref2.hide;

                    return h(
                      'svg-icon',
                      {
                        nativeOn: {
                          'mouseenter': show,
                          'mouseleave': hide
                        },

                        'class': 'svg-common like-link',
                        attrs: { 'icon-class': 'question'
                        }
                      },
                      []
                    );
                  }
                }
              },
              []
            ), this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.see')]
          ), h(
            'a',
            {
              attrs: {
                href: 'javascript:void'
              },
              'class': 'like-link',
              on: {
                'click': this.openHelper
              }
            },
            [this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.options.help')]
          )]
        )
      }]
    };
  },
  render: function render(h) {
    var _this = this;

    return h(
      'el-form-item',
      {
        attrs: { rules: this.rules, prop: this.prop }
      },
      [h(
        'template',
        { slot: 'label' },
        [this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.label'), h(
          'auto-tips',
          {
            attrs: {
              maxLength: 0,
              tooltipProps: {
                effect: 'dark'
              },
              content: this.$t('playTurbo.whole.creativeInfo.form.direction.tips')
            }
          },
          []
        )]
      ), h(
        'el-select',
        {
          style: 'max-width: 100%',
          attrs: { value: this.value,
            disabled: this.disabled,
            placeholder: this.$t('playTurbo.commonTemplate.creativeInfo.form.direction.placeholder')
          },
          on: {
            'input': function input(value) {
              return _this.changeHandler(value);
            }
          }
        },
        [this.options.map(function (item) {
          return h(
            'el-option',
            {
              attrs: {
                value: item.value,
                label: item.label
              },
              key: item.value,
              'class': 'select-option'
            },
            [h(
              'div',
              { 'class': 'label' },
              [item.label]
            ), h(
              'div',
              { 'class': 'desc' },
              [item.desc]
            ), h(
              'div',
              { 'class': 'tips' },
              [item.tips]
            )]
          );
        })]
      )]
    );
  },

  methods: {
    changeHandler: function changeHandler(value) {
      this.$emit('input', value);
    },
    openHelper: function openHelper(event) {
      event.preventDefault();
      event.stopPropagation();
      this.toHelperPage();
    }
  }
};